
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_1761c_9",
  "parent": "awsui_parent_15o6u_1761c_28",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_1761c_28",
  "highlighted": "awsui_highlighted_15o6u_1761c_28",
  "selected": "awsui_selected_15o6u_1761c_28",
  "selectable-item-content": "awsui_selectable-item-content_15o6u_1761c_31",
  "pad-bottom": "awsui_pad-bottom_15o6u_1761c_35",
  "virtual": "awsui_virtual_15o6u_1761c_42",
  "has-background": "awsui_has-background_15o6u_1761c_45",
  "child": "awsui_child_15o6u_1761c_48",
  "disabled": "awsui_disabled_15o6u_1761c_54",
  "is-keyboard": "awsui_is-keyboard_15o6u_1761c_73",
  "visual-refresh": "awsui_visual-refresh_15o6u_1761c_83",
  "next-item-selected": "awsui_next-item-selected_15o6u_1761c_97",
  "previous-item-selected": "awsui_previous-item-selected_15o6u_1761c_107",
  "sticky": "awsui_sticky_15o6u_1761c_139",
  "with-scrollbar": "awsui_with-scrollbar_15o6u_1761c_158",
  "after-header": "awsui_after-header_15o6u_1761c_161",
  "measure-strut": "awsui_measure-strut_15o6u_1761c_190",
  "screenreader-content": "awsui_screenreader-content_15o6u_1761c_202",
  "option-content": "awsui_option-content_15o6u_1761c_208",
  "select-all": "awsui_select-all_15o6u_1761c_212"
};
  